    <template>
      <div class="container mt-5">
        <TokenInventory :page="showTop"/>
      </div>
    </template>

    <script>
    import TokenInventory from "@/views/_comp_token/token_inventory_table";
    export default {
      name: "inventory",
      components: {TokenInventory},
      data() {
        return {
          showTop:'showTop',//显示分页
          address:''
        }
      },
      mounted() {
        this.address=this.$route.params.number
      }
    }
    </script>

    <style scoped>

    </style>
